<template>
  <Breadcrumb />
  <div class="d-flex justify-content-end">
    <router-link to="New" class="btn btn-success btn-action-new-page"
      ><i class="bi bi-plus"></i>
      {{
        $t(
          "MessageTemplates.NewButton",
          {},
          { locale: this.$store.state.activeLang }
        )
      }}</router-link
    >
  </div>
  <Grid :settings="gridSettings" :columns="gridColumns" />
</template>
<script>
export default {
  name: "DesignMessageTemplateList",
  data() {
    return {
      gridSettings: {
        action: "DesignMessageTemplateList",
        requestUrl: String.format("/Lcdp-MessageTemplateList"),
        requestUrlRouteParamNames: [],
        routeRequiredParameters: [
          {
            key: "messageTemplateId",
            value: "publicId",
            isRouteParameter: false,
          },
        ],
        isGatewayRequest: true,
        serialNoLink: `#/ProjectDesign/MessageTemplate/Edit/`,

        allowSearchPanel: false,
        allowExcelExport: false,
        allowDragAndDrop: false,
        allowPaging: true,
        allowDeleting: true,
        deleteActionUrl: "Lcdp-MessageTemplateDelete",
        autoOrderProcess: true,

        buttons: [
          {
            name: "edit",
            cssClass: "btn-warning",
            iconClass: "bi-pencil-square",
            routeButton: true,
            routeObj: {
              name: "DesignMessageTemplateEdit",
              params: {
                messageTemplateId: "",
              },
            },
          },
        ],
      },
      gridColumns: [
        {
          text: this.$t(
            "MessageTemplates.Name",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "name",
          type: "string",
          visible: true,
          width: 200,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "MessageTemplates.TemplateType",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "templateTypeText",
          type: "string",
          visible: true,
          width: 200,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "MessageTemplates.Description",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "description",
          type: "string",
          visible: true,
          width: 200,
          template: "",
          format: "",
          textAlign: "",
        },
        {
          text: this.$t(
            "BaseModelFields.IsActive",
            {},
            { locale: this.$store.state.activeLang }
          ),
          field: "isActive",
          type: "boolean",
          visible: true,
          width: 0,
          template: "",
          format: "",
          textAlign: "",
        },
      ],
    };
  },
  methods: {},
  mounted() {},
};
</script>
